/* ms-barra-compra.js — barra flotante de compra. Reescrita el 2026-09-05,
   corregida el 2026-09-06.

   NO VOLVER A ENGANCHAR EL CLIC. Leer esto entero antes de tocar.

   La version del 5 de septiembre enganchaba un listener de click en fase
   de captura sobre la barra, hacia stopPropagation() y disparaba a mano
   el boton real del formulario. El motivo era que la barra que pinta
   Horizon vive fuera del <form> del producto, y se creia que comprar
   desde ella metia la compra unica en vez de la suscripcion.

   No es asi. StickyAddToCartComponent de Horizon ya dispara el boton
   real del formulario (handleAddToCartClick -> ProductFormComponent
   .handleSubmit), y el input selling_plan viaja con el. Verificado el
   2026-09-06 leyendo el cuerpo de la peticion: selling_plan=692878573832.

   Y el stopPropagation no servia de nada: Horizon escucha en captura
   sobre document, y la captura baja de document al elemento, asi que su
   manejador corre SIEMPRE antes que el de la barra. Resultado: un solo
   clic hacia dos peticiones a /cart/add y metia 2 unidades en el
   carrito, con dos repintados de la seccion del cajon pisandose.

   Lo que si hace este script, y solo esto:

   1. PRECIO Y ROTULO VIVOS. Se leen de la opcion de Seal marcada, no
      del precio del producto, y se reescriben cada vez que Seal repinta
      su widget. En la opcion de suscripcion hay dos importes; el bueno
      es el ultimo que NO cuelga de .sls-original-price, que es el
      tachado.

   2. APARECER SOLO CUANDO TOCA. La barra se muestra cuando el boton de
      compra principal ya ha salido por arriba, no cuando esta por
      llegar. Por eso no basta con isIntersecting: hay que mirar el
      signo de boundingClientRect.top.

   EL RELOJ NO SOBRA. Seal reemplaza su widget entero varias veces al
   cargar. Si la ultima vez que el observador avisa cae justo mientras
   no hay ningun radio marcado, pintar() se va de vacio, despues ya no
   muta nada mas y las variables se quedan sin escribir: el boton se
   queda con el texto de reserva, sin precio. Paso el 2026-09-05 y costo
   tres vueltas encontrarlo, porque a veces la carrera se ganaba y a
   veces no. Se repasa cada 400 ms durante 24 segundos, el mismo patron
   que ya usa ms-precio-sesion.js.

   El precio por sesion se calcula aqui dividiendo entre 21, en vez de
   copiarlo de lo que escribe ms-precio-sesion.js: cuando Seal repinta,
   ese texto tarda un instante en volver y la barra parpadearia.

   Los textos viajan a la hoja de estilos en variables CSS, que es como
   ya funcionaba la linea de detalle. Si este script no llega a correr,
   quedan los valores de defecto y la barra sigue siendo usable.
*/
(function () {
  'use strict';
  if (window.msBarraCompra) return;
  window.msBarraCompra = true;

  var SESIONES = 21;
  var SEL_BARRA = '.sticky-add-to-cart__bar';
  var SEL_PRINCIPAL = '.buy-buttons-block .add-to-cart-button';

  function barra() { return document.querySelector(SEL_BARRA); }
  function principal() { return document.querySelector(SEL_PRINCIPAL); }

  function opcionMarcada() {
    var r = document.querySelector('.sls-purchase-options-container input.sls-option:checked');
    return r ? r.closest('.sls-option-container') : null;
  }

  function precioDe(op) {
    if (!op) return '';
    var cont = op.querySelector('.sls-price-container') || op;
    var monedas = cont.querySelectorAll('.money');
    for (var i = monedas.length - 1; i >= 0; i--) {
      var m = monedas[i];
      if (m.closest('.sls-original-price')) continue;
      var t = (m.textContent || '').trim();
      if (t) return t;
    }
    return '';
  }

  function nombreDe(op) {
    var l = op && op.querySelector('.sls-selling-plan-group-name');
    if (!l) return '';
    /* la insignia de ahorro cuelga del mismo label; nos quedamos con
       los nodos de texto sueltos, que son el nombre */
    var t = '';
    for (var i = 0; i < l.childNodes.length; i++) {
      if (l.childNodes[i].nodeType === 3) t += l.childNodes[i].textContent;
    }
    return (t || l.textContent).trim();
  }

  function aNumero(txt) {
    if (!txt) return NaN;
    var limpio = txt.replace(/[^0-9,.]/g, '').trim();
    limpio = limpio.split('.').join('').replace(',', '.');
    return parseFloat(limpio);
  }

  function porSesion(precio) {
    var v = aNumero(precio);
    if (!isFinite(v) || v <= 0) return '';
    return (v / SESIONES).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' € por sesión';
  }

  /* devuelve true solo si ha conseguido escribir precio */
  function pintar() {
    var bar = barra();
    if (!bar) return false;
    var op = opcionMarcada();
    if (!op) return false;

    var precio = precioDe(op);
    if (!precio) return false;

    var nombre = nombreDe(op);
    var sesion = porSesion(precio);

    var titulo = bar.querySelector('.sticky-add-to-cart__title');
    if (titulo && nombre && titulo.textContent.trim() !== nombre) {
      titulo.textContent = nombre;
    }
    if (sesion) bar.style.setProperty('--ms-sticky-sub', JSON.stringify(sesion));
    bar.style.setProperty('--ms-cta', JSON.stringify('EMPEZAR MI TRATAMIENTO — ' + precio));
    bar.style.setProperty('--ms-cta-movil', JSON.stringify(precio));
    return true;
  }

  function vigilar() {
    var bar = barra();
    var b = principal();
    if (!bar || !b) return;
    if (bar.getAttribute('data-ms-vigilado')) return;
    if (!('IntersectionObserver' in window)) return;
    bar.setAttribute('data-ms-vigilado', '1');
    bar.setAttribute('data-ms-visible', '0');
    new IntersectionObserver(function (ent) {
      for (var i = 0; i < ent.length; i++) {
        var e = ent[i];
        var fuera = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.setAttribute('data-ms-visible', fuera ? '1' : '0');
      }
    }, { threshold: 0 }).observe(b);
  }

  function todo() {
    vigilar();
    return pintar();
  }

  var pendiente = null;
  function diferido() {
    if (pendiente) return;
    pendiente = setTimeout(function () { pendiente = null; todo(); }, 40);
  }

  todo();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todo);
  }
  new MutationObserver(diferido).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  document.addEventListener('change', diferido, true);
  document.addEventListener('shopify:section:load', todo);
  document.addEventListener('visibilitychange', diferido);

  var intentos = 0;
  var reloj = setInterval(function () {
    intentos++;
    todo();
    if (intentos > 60) clearInterval(reloj);
  }, 400);
})();